import React from 'react';
import KabobMenuComponent from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import VirtualAccountOutcomeConfigurationKabobMenuItem from './VirtualAccountOutcomeConfigurationKabobMenuItem';

const KabobMenu = ({ virtualAccountResource }) => {
  // Don't show the menu if you don't have an item in it
  if (!virtualAccountResource.relationship(fr.relationships.facetPlanVirtualAccountOutcomeConfigurationWizard.name)) {
    return null;
  }

  return (
    <KabobMenuComponent>
      <VirtualAccountOutcomeConfigurationKabobMenuItem virtualAccountResource={virtualAccountResource} />
    </KabobMenuComponent>
  );
};

KabobMenu.propTypes = {
  virtualAccountResource: PropTypes.object.isRequired,
};

export default KabobMenu;
